import ConfiguredRoutes from './ConfiguredRoutes.container';

export default ConfiguredRoutes;
